import React from 'react';
import { Box } from '@material-ui/core';

export const BubbleContainer = ({
    children,
    position = 'left',
    bgColor = '#FFF',
}: {
    children: React.ReactNode;
    position?: 'left' | 'right';
    bgColor: string;
}) => {
    const isRight = position === 'right';

    return (
        <Box
            display="flex"
            justifyContent={isRight ? 'flex-end' : 'flex-start'}
            mb={1}
        >
            <Box
                position="relative"
                style={{
                    background: bgColor,
                    padding: '10px 14px',
                    borderRadius: 16,
                    maxWidth: 400,
                    wordBreak: 'break-word',
                }}
            >
                {children}

                <svg
                    width="16"
                    height="20"
                    viewBox="0 0 16 20"
                    style={{
                        position: 'absolute',
                        bottom: 10,
                        [isRight ? 'right' : 'left']: -14,
                    }}
                >
                    {isRight ? (
                        <path d="M0 0 L16 10 L0 20 Z" fill={bgColor} />
                    ) : (
                        <path d="M16 0 L0 10 L16 20 Z" fill={bgColor} />
                    )}
                </svg>
            </Box>
        </Box>
    );
};
